import { I18n } from '@affine/i18n';

import type { SignedPdfVersionInfo } from '../../../desktop/dialogs/setting/workspace-setting/signatures/use-workspace-pdf-signatures';
import { getSignatureValidationStateLabel } from './pdf-signing-status-labels';

/** The mark on a signed copy: that it is signed, and how its check went. */
export function getSignedPdfBadgeLabel(
  version: Pick<SignedPdfVersionInfo, 'validationState'>
) {
  return I18n.t('com.streamlain.pdf.signature.signedBadge.label', {
    status: getSignatureValidationStateLabel(version.validationState),
  });
}

export function getSignedPdfBadgeTitle() {
  return I18n.t('com.streamlain.pdf.signature.signedBadge.title');
}

/** Why a signed copy offers no signing tools. */
export function getSignedPdfCopyLockedLabel() {
  return I18n.t('com.streamlain.pdf.signature.signedCopy.locked');
}

export function getPlaceSignedPdfCopyLabel() {
  return I18n.t('com.streamlain.pdf.signature.signedCopy.placeOnCanvas');
}

export function getPlacingSignedPdfCopyLabel() {
  return I18n.t('com.streamlain.pdf.signature.signedCopy.placingOnCanvas');
}

export function getSignedPdfCopyPlacedLabel() {
  return I18n.t('com.streamlain.pdf.signature.signedCopy.placedOnCanvas');
}
